module.exports = __webpack_public_path__ + "static/media/service_address_1.2df30f9f.png";